import { useLanguage } from 'store/locale/hooks/useLanguage'
import { getNotFoundContent } from 'data/navigation/not-found'

export interface INotFoundItem {
  language: string
  main1: string
  main2: string
  sub1: string
  sub2: string
}

export const useNotFound = () => {
  const { language } = useLanguage()
  return getNotFoundContent({ language })
}
